// @ts-ignore
export * as namespaceMapping from '../common/namespaceMapping'
export * as newSchemaService from './newSchemaService'
export * as schemas from './configs/schemas'
export * as restrictiveSchemas from './configs/restrictiveSchemas'
export * as schemaArrangement from './schemaArrangement'
export * as componentTypeAliases from './schemas/componentTypeAliases'
export * as skinsByComponentType from './schemas/skinsByComponentType'
export * as schemaConfigs from './configs/schemaConfigs'
export * as schemaUtils from './schemas/schemaUtils'
export * from '../build/enums-convertor'
export * as cssFormats from './configs/cssFormats'
//Used by @wix-private/dm-server
export {convertNamespaceToAbsoluteUrn} from '../common/convertNamespaceToAbsoluteUrn'
import variablesManifest from './namespaces/variables/variablesManifest.json'
export {variablesManifest}
import references from './namespaces/data/references.json'
export {references}
import compoundCompatibility from '../dist/compoundCompatibility.json'
export {compoundCompatibility}
